import styled from "styled-components"
import { COLOR, FONT_SIZE } from "../../themes"
export const InputFieldAutosuggestStyle = styled.div`

  .input-field {
    border: none;
    width: 100%;
    border-radius: 4px;
    outline: none;
  }

  .disabled,
  .disabled * {
    background-color: ${COLOR.GRAY_2} !important;
    color: ${COLOR.GRAY_15} !important;
    cursor: not-allowed !important;
  }

  .icon-search-dropdown {
    width: 42px;
    height: 18px;
    vertical-align: middle;
  }
  .input-search-dropdown {
    width: calc(100% - 70px);
    margin-left: 16px;
    border: none;
    outline: none;
    line-height: 36px;
    font-family: NunitoRegular;
    font-size: ${FONT_SIZE.TN};
    ::placeholder {
      font-size: ${FONT_SIZE.TN};
      color: ${COLOR.GRAY_3};
    }
  }

  .div-search-select {
    border: 1px solid ${COLOR.GRAY_6};
    border-radius: 4px;
    box-shadow: none;
    color: ${COLOR.BLACK_1};
    width: auto;
  }

  .icon-cancel, .icon-cancel-dropdown {
    cursor: pointer
  }

  .icon-cancel {
    width: 42px;
    height: 16px;
    vertical-align: middle;
  }

  .icon-cancel-dropdown {
    width: 42px;
    height: 16px;
    vertical-align: middle;
  }
`